
<v-main>
	<v-container class="fill-height justify-center text-center" fluid>
		<v-form ref="locumRatesForm" class="pa-4 pt-1">
			<v-row class="justify-center text-center">
				<v-col>
					<p class="text-h5 font-weight-bold">Hourly rate on Weekdays</p>
				</v-col>
			</v-row>

			<v-row no-gutters class="justify-center text-center pb-5">
				<v-text-field
					:disabled="hasFixedRates"
					single-line
					outlined
					class="rate-number pr-0 pl-0 mr-0 ml-0 pt-0 pb-2"
					style="outline-color: #f00 !important"
					:color="weekday_focus ? 'primary' : '#A3A3A3'"
					height="50px"
					:value="weekdayrateFormatted"
					:rules="weekdayrateRules"
					@focus="onFocus('weekday')"
					@change="change_weekdayrate"
				></v-text-field>
			</v-row>

			<v-row class="justify-center text-center pt-5">
				<v-col>
					<p class="text-h5 font-weight-bold">Hourly rate on Saturdays</p>
				</v-col>
			</v-row>

			<v-row no-gutters class="justify-center text-center pb-5">
				<v-text-field
					:disabled="hasFixedRates"
					single-line
					outlined
					class="rate-number pr-0 pl-0 mr-0 ml-0 pt-0 pb-2"
					:color="saturday_focus ? 'primary' : '#A3A3A3'"
					height="50px"
					:value="saturdayrateFormatted"
					:rules="saturdayrateRules"
					@focus="onFocus('saturday')"
					@change="change_saturdayrate"
				></v-text-field>
			</v-row>

			<v-row class="justify-center text-center pt-5">
				<v-col>
					<p class="text-h5 font-weight-bold">Hourly rate on Sundays and Holidays</p>
				</v-col>
			</v-row>

			<v-row no-gutters class="justify-center text-center">
				<v-text-field
					:disabled="hasFixedRates"
					single-line
					outlined
					class="rate-number pr-0 pl-0 mr-0 ml-0 pt-0 pb-2"
					:color="holiday_focus ? 'primary' : '#A3A3A3'"
					height="50px"
					:value="this.holidayrateFormatted"
					:rules="sundayrateRules"
					@focus="onFocus('holiday')"
					@change="change_holidayrate"
				></v-text-field>
			</v-row>
		</v-form>
		<v-row v-if="this.solo">
			<v-btn text @click="$refs.locumRatesForm.reset()">Clear</v-btn>
			<v-spacer></v-spacer>
			<v-btn class="white--text" color="deep-purple accent-4" depressed @click="SubmitForm()">Update</v-btn>
		</v-row>
	</v-container>
</v-main>
